import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { MosError } from 'src/utils/errors/MosError';
import { isMockServices } from 'src/utils';
import mock from '../utils/mock';

export interface GetSyncStatusResponse {
  success: boolean;
  data:
    | {
        status: 'completed' | 'failed' | 'pending';
        initiatedAt?: string;
        completedAt: string;
        duration_ms: number | null;
        loansFound: number | null;
        loansLinked: number | null;
        loansSkipped: number | null;
        taskId: string;
      }
    | {
        status: 'failed' | 'completed' | 'pending';
        initiatedAt?: string;
        failedAt: string;
        error: { code: string; message: string };
        taskId: string;
      }
    | {
        status: 'pending' | 'failed' | 'completed';
        initiatedAt?: string;
        taskId: string;
      };
}
const getSyncStatus: QueryFunction<
  GetSyncStatusResponse,
  ['/loans/sync-status', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetSyncStatusResponse>(
    `/loans/sync-status?taskId=${queryKey[1]}`,
    {
      method: 'GET',
    },
  );
  if (response.data) return response.data;
  throw new MosError({
    error: 'Failed to get sync status',
    statusCode: response.status,
  });
};

export default getSyncStatus;

const _mockData: GetSyncStatusResponse = {
  success: true,
  data: {
    status: 'pending',
    taskId: 'mock-1',
  },
};
